/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */
import { jsx, css } from '@emotion/react'

import { EuiFlexItem, EuiPanel, EuiSkeletonText, useEuiTheme } from '@elastic/eui'

import { CuiStat } from '@modules/cui/Stat'
import type { CuiLink } from '@modules/cui/Link'
import type { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent, ReactElement } from 'react'

interface Props {
  title: ReactElement<typeof FormattedMessage>
  value?: number | ReactElement<typeof CuiLink> | null
}

const PlatformStatsTile: FunctionComponent<Props> = ({ title, value }) => {
  const { euiTheme } = useEuiTheme()

  const valueStyles = css({
    fontSize: euiTheme.size.l,
    marginTop: euiTheme.size.m, // $euiSizeM
  })

  return (
    <EuiFlexItem grow={false}>
      <EuiPanel>
        <CuiStat
          statElement='strong'
          title={
            <div css={valueStyles}>
              {value == null ? (
                <EuiSkeletonText lines={1} data-test-id='platform-stat-loading' />
              ) : (
                value
              )}
            </div>
          }
          description={title}
          data-test-id='platform-stat'
        />
      </EuiPanel>
    </EuiFlexItem>
  )
}

export default PlatformStatsTile
